<template>
    <v-col :cols="cols" :sm="sm" :md="md">
        <v-text-field
            v-model="model"
            :label="label"
            :append-icon="appendIcon"
            :append-outer-icon="appendOuterIcon"
            :prepend-icon="prependIcon"
            :prepend-inner-icon="prependInnerIcon"
            :readonly="readonly"
            :disabled="disabled"
            :outlined="outlined"
            :type="type"
            :hint="hint"
            :background-color="outlined && disabled ? `grey lighten-2` : undefined"
            :hide-details="hideDetails"
            :error="error"
            :error-messages="errorMessages"
            :autofocus="autofocus"
            :dense="dense"
        >
        </v-text-field>
    </v-col>
</template>

<script>
export default {
    name: 'EmcFormTextField',
    props: {
        type: { type: String, default: "text" },
        value: [String, Number],
        label: { type: String, required: false },
        appendIcon: { type: String, required: false },
        appendOuterIcon: { type: String, required: false },
        prependIcon: { type: String, required: false },
        prependInnerIcon: { type: String, required: false },
        readonly: { type: Boolean, required: false },
        disabled: { type: Boolean, required: false },
        outlined: { type: Boolean, required: false },
        sm: { type: String, default: "6" },
        md: { type: String, default: "4" },
        cols: { type: String, default: "12" },
        hint: { type: String, required: false },
        hideDetails: { type: [String, Boolean], default: "auto"},
        errorMessages: { type: [Object, Array], required: false },
        error: { type: Boolean, required: false },
        autofocus: { type: Boolean, default: false },
        dense: { type: Boolean, default: false },
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    }
}
</script>